module.exports = __webpack_public_path__ + "7a20aba329c72c6eff79540019e076e1.png";